import type { ChatMessage, LeadPayload, QuickReply } from "../lib/types";
import LeadCaptureForm from "./LeadCaptureForm";
import MessageInput from "./MessageInput";
import MessageList from "./MessageList";
import QuickReplies from "./QuickReplies";

type ChatWindowProps = {
  loading: boolean;
  ready: boolean;
  sending: boolean;
  error: string | null;
  messages: ChatMessage[];
  quickReplies: QuickReply[];
  leadCaptureVisible: boolean;
  canSubmitLead: boolean;
  onClose: () => void;
  onQuickReply: (quickReplyId: string, label: string) => void;
  onSendMessage: (message: string) => void;
  onSubmitLead: (lead: LeadPayload) => void;
  onDismissLeadCapture: () => void;
};

export default function ChatWindow({
  loading,
  ready,
  sending,
  error,
  messages,
  quickReplies,
  leadCaptureVisible,
  canSubmitLead,
  onClose,
  onQuickReply,
  onSendMessage,
  onSubmitLead,
  onDismissLeadCapture
}: ChatWindowProps) {
  return (
    <section className="qk-chatbot-window" aria-label="Chat Quiky Studio">
      <header className="qk-chatbot-header">
        <div>
          <p className="qk-chatbot-title">Assistant</p>
          <p className="qk-chatbot-status">{loading ? "Chargement" : "En ligne"}</p>
        </div>
        <button className="qk-chatbot-icon-button" type="button" aria-label="Fermer" onClick={onClose}>
          &times;
        </button>
      </header>

      <MessageList messages={messages} loading={loading || sending} />

      {error && <p className="qk-chatbot-error">{error}</p>}

      {!loading && ready && quickReplies.length > 0 && (
        <QuickReplies quickReplies={quickReplies} disabled={sending} onSelect={onQuickReply} />
      )}

      {leadCaptureVisible && (
        <LeadCaptureForm
          disabled={sending || !canSubmitLead}
          onSubmit={onSubmitLead}
          onDismiss={onDismissLeadCapture}
        />
      )}

      <MessageInput disabled={loading || sending || !ready} onSend={onSendMessage} />
    </section>
  );
}
